export function useEnterpriseClient() {
  const { enterpriseClient } = useSessionData()
  const isPeloton = ['peloton', 'peloton-staging'].includes(enterpriseClient)
  return { enterpriseClient, isPeloton }
}
